import "../RevAudReport/RevAudReport.css";

import { Fragment } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";

import { mapReviewReport } from "../RevAudReport/RevAudReport.utils";

const mapRequestedComments = (data: any) =>
  mapReviewReport({
    data: {
      result: Object.values(data.data.entry).map((entry: any) => ({
        ...entry,
        reverify: entry.comments,
      })),
      comments: data.data.summary,
    },
  });

const RequestedComments = () => {
  const { aid } = useParams();
  const { data, isLoading } = useGetApi({
    request: "get-requested-comments",
    body: { params: { aid, yachtid: getYachtId() } },
    mapper: mapRequestedComments,
  });
  return (
    <PageContainer>
      <Breadcrumbs customLinks={links => links.splice(2)} border={false} />
      {isLoading && <Loader />}
      {!isLoading && (
        <div style={{ width: 1080 }}>
          <div className="frame">
            <div className="frame-header">
              <p className="frame-header-title">SUMMARY COMMENTS</p>
            </div>
            <div className="frame-content">
              {data?.comments.length === 0 && <p>No Comments...</p>}
              {data?.comments.length > 0 &&
                data?.comments.map((comment: any) => (
                  <div key={comment.header} className="comment">
                    <p className="comment-header">{comment.header}</p>
                    <p className="comment-content">{comment.content}</p>
                  </div>
                ))}
            </div>
          </div>
          <div className="frame">
            <div className="frame-header">
              <p className="frame-header-title">ENTRIES</p>
            </div>
            <table className="entries-table">
              <thead>
                <tr>
                  <th>
                    <p>Entry Ref</p>
                  </th>
                  <th>
                    <p>Logbook Title</p>
                  </th>
                  <th>
                    <p>Entry Date</p>
                  </th>
                  <th>
                    <p>Entry Status</p>
                  </th>
                </tr>
              </thead>
              {data?.entries.length > 0 && (
                <tbody>
                  {data?.entries.map((entry: any) => (
                    <Fragment key={entry.ref}>
                      <tr className="row-entry">
                        <td>
                          <p>{entry.ref}</p>
                        </td>
                        <td>
                          <p>{entry.title}</p>
                        </td>
                        <td>
                          <p>{entry.date}</p>
                        </td>
                        <td>
                          <p>{entry.status}</p>
                        </td>
                      </tr>
                      {entry.comments.length > 0 && (
                        <tr className="row-entry-comments">
                          <td colSpan={4}>
                            <div>
                              {entry.comments.map((comment: any) => (
                                <div key={comment.header} className="comment">
                                  <p className="comment-header">
                                    {comment.header}
                                  </p>
                                  <p className="comment-content">
                                    {comment.content}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  ))}
                </tbody>
              )}
            </table>
            {data?.entries.length === 0 && (
              <div className="frame-content">
                <p>No Entries...</p>
              </div>
            )}
          </div>
        </div>
      )}
    </PageContainer>
  );
};

export default RequestedComments;
